import find from 'lodash/find'
import filter from 'lodash/filter'
import isEqual from 'lodash/isEqual'
import isNull from 'lodash/isNull'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import forEach from 'lodash/forEach'
import moment from 'moment'
import { toggleArrayValue, cloneArray } from 'shared/helper'

function getFilterIdByType(filterValues, filterType) {
  const allFilter = find(filterValues, { [filterType]: true })
  return allFilter ? allFilter.id : null
}
function isAllValuesSelected (filterState, specificIds) {
  return isEqual(filterState.sort(), specificIds.sort()) || isEmpty(filterState)
}

function getMultiChoiceFilterValues (filterState, selectedValue, filterValues) {
  const allFilterId = getFilterIdByType(filterValues, 'is_all')
  const noneFilterId = getFilterIdByType(filterValues, 'is_none')
  const specificIds = filter(filterValues, f => !f.is_all).map(f => f.id)
  let newFilterState = cloneArray(filterState)

  if (newFilterState.includes(allFilterId) || newFilterState.includes(noneFilterId)) {
    newFilterState = []
  }

  if (!!selectedValue.is_all || !!selectedValue.is_none) {
    newFilterState = [selectedValue.id]
  } else {
    toggleArrayValue(newFilterState, selectedValue.id)
  }

  if (allFilterId &&
    (isAllValuesSelected(newFilterState, specificIds) || isEmpty(newFilterState))) {
    newFilterState = [allFilterId]
  }

  if (!isNull(noneFilterId) && isEmpty(newFilterState)) {
    newFilterState = [noneFilterId]
  }

  return newFilterState
}

export function getFilterValue (filter, filterState, selectedValue) {
  if (filter.is_multi_choice) {
    return getMultiChoiceFilterValues(filterState, selectedValue, filter.values)
  } else {
    return [selectedValue.id]
  }
}

function getFilterByType (allFilters, type) {
  const filters = {}

  forEach(allFilters, (filter) => {
    filters[filter.name] = [get(find(filter.values, { [type]: true }), 'id')]
  })

  return filters
}

export function getDefaultFilters (allFilters) {
  return getFilterByType(allFilters, 'default')
}

function getFilterByName (allFilters, filterName) {
  return find(allFilters, { name: filterName })
}

function getDefaultDateRange (creationDate) {
  return {
    startDate: moment(creationDate).toDate(),
    endDate: moment().endOf('day').toDate()
  }
}

export function prepareBoardFilters ({ filters, urlFilters, boardCreationDate }) {
  const FILTERS_NAME = {
    mailBlastId: 'campaign'
  }

  const activeFilters = getDefaultFilters(filters)
  const defaultFilters = getFilterByType(filters, 'is_all')
  const defaultDateRange = getDefaultDateRange(boardCreationDate)

  activeFilters.date_range = defaultDateRange
  defaultFilters.date_range = defaultDateRange

  // set default filter
  Object.keys(urlFilters).forEach((urlFilterName) => {
    const filterName = FILTERS_NAME[urlFilterName]
    const filter = getFilterByName(filters, filterName)
    const filterOptions = filter.values.find(option => option.id === urlFilters[urlFilterName])
    if (!!filterOptions && !!filter) {
      activeFilters[filterName] = getFilterValue(filter, activeFilters[filterName], filterOptions)
    }
  })

  return {
    defaultFilters,
    activeFilters,
    filters
  }
}

export function getUpdatedActiveFiltersBySelection ({ filters, filterName, activeFilters, selected }) {
  const filter = getFilterByName(filters, filterName)
  const filterState = activeFilters[filterName]
  return {
    ...activeFilters,
    [filterName]: getFilterValue(filter, filterState, selected)
  }
}
